import { currentBillingAddressStyles } from "@insite/content-library/Widgets/Addresses/CurrentBillingAddress";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS, TYPOGRAPHY } from "@tecumseh/theme/design";
import { css } from "styled-components";

currentBillingAddressStyles.editLink = {
    css: css`
        > span {
            color: ${getColor("primary")} !important;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    css`
                        font-size: ${TYPOGRAPHY.size.smallest};
                    `,
                    css`
                        font-size: ${TYPOGRAPHY.size.smallest};
                    `,
                    css`
                        font-size: ${TYPOGRAPHY.size.smallest};
                    `,
                    null,
                ])}
        }
    `,
};

currentBillingAddressStyles.addressInfoDisplayGridItem = {
    width: 12,
    css: css`
        > address {
            font-size: ${TYPOGRAPHY.size.smaller};
        }
    `,
};
